"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_select_1 = __importDefault(require("react-select"));
var config_1 = require("../config");
var Input_1 = require("../Input");
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var SelectWithSearch = /** @class */ (function (_super) {
    __extends(SelectWithSearch, _super);
    function SelectWithSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.updateLocale = function () {
            _this.forceUpdate();
        };
        LocaleProvider_1.default.on(_this.updateLocale);
        return _this;
    }
    SelectWithSearch.prototype.componentWillUnmount = function () {
        LocaleProvider_1.default.off(this.updateLocale);
    };
    SelectWithSearch.prototype.render = function () {
        var localization = LocaleProvider_1.default.locs.select;
        var _a = this.props, className = _a.className, placeholder = _a.placeholder, noOptionsMessage = _a.noOptionsMessage, variant = _a.variant, singleValueRender = _a.singleValueRender, optionsRender = _a.optionsRender, others = __rest(_a, ["className", "placeholder", "noOptionsMessage", "variant", "singleValueRender", "optionsRender"]);
        var b = config_1.block("select_with_search");
        var noOptionsDefaultMessage = function () { return localization.empty; };
        var cn = b({
            grey: variant === Input_1.InputVariant.Grey,
            white: variant === Input_1.InputVariant.White,
        }).mix(className);
        var components = {};
        if (singleValueRender) {
            components.SingleValue = singleValueRender;
        }
        if (optionsRender) {
            components.Option = optionsRender;
        }
        return (react_1.default.createElement(react_select_1.default, __assign({ maxMenuHeight: 200, isSearchable: true, noOptionsMessage: noOptionsMessage || noOptionsDefaultMessage, placeholder: placeholder || localization.select, className: cn, classNamePrefix: b(), components: components }, others)));
    };
    SelectWithSearch.defaultProps = {
        variant: Input_1.InputVariant.Grey,
    };
    return SelectWithSearch;
}(react_1.default.Component));
exports.default = SelectWithSearch;
//# sourceMappingURL=index.js.map